<template>
  <v-app>
    <v-snackbar v-model="snackbar" :color="snackbar_color" top>
      {{ snackbar_text }}
      <v-btn text outlined @click="snackbar = false" color>Cerrar</v-btn>
    </v-snackbar>
    <pages-core-app-bar />

    <pages-core-view />

    <pages-core-footer />
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { goPanel } from "@/utils/router.js";
export default {
  name: "PagesIndex",

  components: {
    PagesCoreAppBar: () => import("./components/core/AppBar"),
    PagesCoreFooter: () => import("./components/core/Footer"),
    PagesCoreView: () => import("./components/core/View"),
  },

  created() {
    this.$vuetify.theme.dark = true;
  },

  beforeDestroy() {
    this.$vuetify.theme.dark = false;
  },
  computed: {
    snackbar: {
      get() {
        return this.$store.state.snackbar.show;
      },
      set(value) {
        this.$store.commit("snackbar/reset");
      },
    },
    ...mapState({
      isLogged: (state) => state.auth.isLogged,
      isLoaded: (state) => state.loaded,
      snackbar_text: (state) => state.snackbar.text,
      snackbar_color: (state) => state.snackbar.color,
    }),
  },
  mounted() {
    if (this.isLogged && !this.$route.path.includes("/comprobarfirma")) {
      this.$router.push(goPanel());
    }
  },
};
</script>
